import { render, staticRenderFns } from "./BaseRadioButtonGroup.vue?vue&type=template&id=5416b8f8"
import script from "./BaseRadioButtonGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./BaseRadioButtonGroup.vue?vue&type=style&index=0&id=5416b8f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports